/*
	Generated on 12/02/2025 by UI Generator PRICES-IDE
	https://amanah.cs.ui.ac.id/research/ifml-regen
	version 3.5.14
*/
import RequireAuth from '@/commons/auth/RequireAuth'

import LihatIRSPage from './containers/LihatIRSPage'

const lihatIRSRoutes = [
{ 
	path: "/irs/ringkasan",
	element: <LihatIRSPage />,
}

	

]

export default lihatIRSRoutes
